<template>
  <div></div>
</template>

<script>
export default {
  mounted () {
    this.$router.replace({ path: '/login' })
  }
}
</script>
